import { useNavigate } from "react-router-dom";
import { LogOut, Users, Building2, LayoutGrid, LayoutDashboard } from "lucide-react";
import logo from "@/assets/planet-smoothie-logo.png";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { isSuperAdmin } from "@/components/ProtectedRoute";

export function TopNav() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const superAdmin = isSuperAdmin(user?.role);
  const franchiseAdmin = user?.role === "franchisee_admin";

  const handleSignOut = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <header className="bg-primary text-primary-foreground shadow-md">
      <div className="container mx-auto px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img src={logo} alt="Planet Smoothie" className="h-10 object-contain brightness-0 invert" data-testid="topnav-logo" />
        </div>
        <h1 className="hidden md:block text-lg font-bold tracking-tight">
          Local Store Marketing Dashboard
        </h1>
        <div className="flex items-center gap-2">
          {(superAdmin || franchiseAdmin) && (
            <Button variant="ghost" size="sm" data-testid="topnav-dashboard"
              className="text-primary-foreground hover:bg-primary-foreground/20 gap-2"
              onClick={() => navigate("/dashboard")}>
              <LayoutDashboard className="h-4 w-4" />
              <span className="hidden sm:inline">Dashboard</span>
            </Button>
          )}
          {superAdmin && (
            <Button variant="ghost" size="sm" data-testid="topnav-admin"
              className="text-primary-foreground hover:bg-primary-foreground/20 gap-2"
              onClick={() => navigate("/admin")}>
              <LayoutGrid className="h-4 w-4" />
              <span className="hidden sm:inline">Platform</span>
            </Button>
          )}
          {(superAdmin || franchiseAdmin) && (
            <Button variant="ghost" size="sm" data-testid="topnav-franchise"
              className="text-primary-foreground hover:bg-primary-foreground/20 gap-2"
              onClick={() => navigate("/franchise")}>
              <Building2 className="h-4 w-4" />
              <span className="hidden sm:inline">Franchise</span>
            </Button>
          )}
          {superAdmin && (
            <Button variant="ghost" size="sm" data-testid="topnav-users"
              className="text-primary-foreground hover:bg-primary-foreground/20 gap-2"
              onClick={() => navigate("/users")}>
              <Users className="h-4 w-4" />
              <span className="hidden sm:inline">Team</span>
            </Button>
          )}
          <Button variant="ghost" size="icon" title="Sign Out" data-testid="logout-button"
            className="text-primary-foreground hover:bg-primary-foreground/20"
            onClick={handleSignOut}>
            <LogOut className="h-5 w-5" />
          </Button>
        </div>
      </div>
    </header>
  );
}
